/** 
 * Timezone functionality should be localized to EST.
*/


(function(){
    const intersection = (a, b) => {
        const s = new Set(b);
        return [...new Set(a)].filter(x => s.has(x));
    };

    class GWP {
        constructor({
            container = null,
        }) {
            console.log('GWP Started');


            this.$selectors = {
                checkoutBtn: 'form[action="/cart"] button[name="checkout"]',
                container,
                list: `${container} .gwp-list`,
            }


            this.collections = {};
            this.cart = this.getJSON('[data-cart]');
            this.products = [];
            this.settings = this.getJSON('[data-gwp]');


            console.log('Cart, Settings', this.cart, this.settings);
            // Private Functions
            this.addHandlers = this.addHandlers.bind(this);
            this.addClickHandler = this.addClickHandler.bind(this);
            this.buildSlides = this.buildSlides.bind(this);
            this.checkGWPQuantities = this.checkGWPQuantities.bind(this);
            this.disclaimer = this.disclaimer.bind(this);
            this.getCart = this.getCart.bind(this);
            this.getCollectionHandles = this.getCollectionHandles.bind(this);
            this.identifyActiveCampaign = this.identifyActiveCampaigns.bind(this);
            this.initialize = this.initialize.bind(this);
            this.slickHandlers = this.slickHandlers.bind(this);
            this.startSlick = this.startSlick.bind(this);
            this.updateCollectionHandles = this.updateCollectionHandles.bind(this);



            this.initialize();
        }

        addClickHandler(event) {
            event.preventDefault();
            const btn = event.currentTarget;
            const variantID = btn.getAttribute('data-add');

            const adding = {
                id: Number(variantID),
            };

            this.addProduct(adding);
        }

        addHandlers() {
            const list = document.querySelector(this.$selectors.list);
            const adds = list.querySelectorAll('.add-gwp');

            [...adds].forEach((btn) => {
                btn.addEventListener('click', this.addClickHandler);
            });
        }

        addProduct({ id, quantity = 1 }) {
            const addData = {
                items: [
                    {
                        id,
                        quantity,
                        properties: {
                            'Purchase Type': 'Gift',
                        }
                    }
                ]
            };

            console.warn('Add', addData);

            return fetch('/cart/add.js', {
                body: JSON.stringify(addData),
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                },
                method: 'POST'
            }).then(function(response) {
                return response.json();
            }).then(function(json) {
                /* we have JSON */
                console.log('GWP Added', json);
                window.location.reload();
            }).catch(function(err) {
                /* uh oh, we have error. */
                console.error(err)
            });
        }

        buildSlides() {
            const { products } = this;
            const html = products.map(function(product) {
                return `
                <div class="gwp-slide-wrapper">
                    <div class="gwp-slide">
                        <div class="slide-img-wrapper">
                            <img src="${product.featured_image}" alt="${product.title}" />
                        </div>
                        <div class="slide-content-wrapper">
                            <span>${product.title}</span>
                            <span>FREE</span>
                            <button type="button" class="add-gwp" data-add="${product.variants[0].id}">ADD TO CART</button>
                        </div>
                    </div>
                </div>
                `;
            });

            return html.join('');
        }

        changeProduct({ id, quantity }) {
            const changeData = {
                id,
                quantity,
            };

            return fetch('/cart/change.js', {
                body: JSON.stringify(changeData),
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                },
                method: 'POST'
            }).then(function(response) {
                return response.json();
            }).then(function(json) {
                /* we have JSON */
                console.log('GWP Changed', json);
                window.location.reload();
            }).catch(function(err) {
                /* uh oh, we have error. */
                console.error(err)
            });
        }

        checkGWPQuantities() {
            const {cart, settings} = this;
            const gwpWithExtraQty = cart.items.find(function(item) {
                return item.properties['Purchase Type'] === 'Gift' && item.quantity > 1;
            });

            if (gwpWithExtraQty) {
                const { key } = gwpWithExtraQty;
                
                this.changeProduct({ 
                    id: key,
                    quantity: 1,
                });

                return;
            }

            const activeCampaigns = this.identifyActiveCampaigns(true);

            if (activeCampaigns.length === 0) {
                const gwpItem = cart.items.find(function(item) {
                    return item.properties['Purchase Type'] === 'Gift';
                });
    
                const { key } = gwpItem;
                
                this.changeProduct({ 
                    id: key,
                    quantity: 0,
                });

                return;
            }
            console.log('Checking Quantities', activeCampaigns);
        }

        disclaimer() {
            const disclaimer = document.createElement('p');

            disclaimer.classList += ' disclaimer gwp-disclaimer';
            disclaimer.textContent = 'Select a free gift before checking out';

            const checkoutBtn = document.querySelector(this.$selectors.checkoutBtn);
            const inputParent = document.querySelector(this.$selectors.checkoutBtn).parentElement;

            inputParent.insertBefore(disclaimer, checkoutBtn.nextElementSibling);
        }

        async fetchProducts() {
            const {campaigns} = this;
            const gwpProductHandles = campaigns.map(function(campaign) {
                return campaign.gift_product;
            });

            const gwpProducts = await Promise.all(gwpProductHandles.map(this.getProduct));

            this.products = this.products.concat(gwpProducts);
            console.warn('GWP PRODUCTS', gwpProducts);
        }

        getCart() {
            return fetch('/cart.js')
                    .then(function(res) {
                        return res.json();
                    })
                    .catch(function(error) {
                        console.warn('ERROR FETCHING CART', error);
                        return error;
                    })
        }

        getJSON(selector) {
            return JSON.parse(document.querySelector(selector).innerHTML);
        }

        getProduct(handle) {
            return fetch(`/products/${handle}.js`)
                    .then(function(res){
                        return res.json()
                    })
                    .catch(function(error){
                        console.log('ERROR FETCHING PRODUCT', error);
                        return error;
                    })
        }

        identifyActiveCampaigns(force = false) {
            const {cart, collections, settings} = this;

            const cartHasGWP = cart.items.find(function(item) {
                return item.properties && item.properties['Purchase Type'] === 'Gift';
            });

            if (cartHasGWP && !force) {
                this.checkGWPQuantities();
                return [];
            }

            const cartItemHandles = cart.items.map(function(item) {
                return item.handle;
            });

            console.log('Searching for Active campaign', collections, cartItemHandles);

            const activeCampaign = settings.filter(function(campaign) {
                const {type} = campaign;

                if (type === 'GWP-Amount') {
                    const triggerAmount = Number(campaign.amount) * 100;

                    return triggerAmount <= cart.total_price;
                }

                if (campaign.trigger_collection) {
                    const { trigger_collection } = campaign;
                    const intersectionOfHandles = intersection(collections[trigger_collection], cartItemHandles);

                    console.log('Intersection?', intersectionOfHandles, trigger_collection);

                    if(intersectionOfHandles.length > 0) return true;
                }

                return cartItemHandles.includes(campaign.trigger_product);
            });


            return activeCampaign;
        }

        toLocalizedISO(dateString) {
            const [date, time] = dateString.split(' ');
            const [month, day, year] = date.split('/');
            const [hour, minutes] = time.split(':');

            const localTime = luxon.DateTime.fromObject({
                day,
                month,
                year,
                hour,
                minutes,
                zone: 'America/New_York'
              }).toISO();

              return localTime;
        }

        localToEST() {
            return luxon.DateTime.local().setZone('America/New_York').toISO();
        }

        inDateRange(start, end) {
            if(!start || !end) return true;

        }

        fetchHandles(handle, page) {
            return fetch(`/collections/${handle}?view=handles&page=${page}`)
                    .then((res) => res.json())
                    .catch(() => {
                        // return empty handle set so no errors get tossed.
                        return {
                            handles: [],
                        }
                    })
        }

        updateCollectionHandles(handle, handles) {
            this.collections[handle] = this.collections[handle] || [];

            this.collections[handle] = this.collections[handle].concat(handles);
        }

        async getCollectionHandles() {
            const { collections } = this;

            const localTimeAsEST = this.localToEST();
            const qualifyByTime = this.settings.filter((block) => {
                // reject if no collection.
                if(!block.trigger_collection) return false;

                // accept if no times set. ( No Time Constraint )
                if(!block.times.start || !block.times.end) return true;

                const startISO = this.toLocalizedISO(block.times.start);
                const endISO = this.toLocalizedISO(block.times.end);

                const localDate = new Date(localTimeAsEST);
                const startDate = new Date(startISO);
                const endDate = new Date(endISO);

                return (startDate < localDate) && (localDate < endDate);

            });

            console.log('Collection Handles', collections, this.settings, qualifyByTime);

            await Promise.all(qualifyByTime.map(async (block) => {
                const { trigger_collection, trigger_collection_count } = block;
                let index = 0;
                let pages = Math.ceil(trigger_collection_count / 1000);

                while(index < pages) {
                    const result = await this.fetchHandles(trigger_collection, index+1);
                    const {handles} = result;

                    this.updateCollectionHandles(trigger_collection, handles);

                    index++;
                }

                return block;
            }));

            console.log('After Promise', this.collections);


            return true;
        }

        async initialize() { 
            // Get Relevant collection data
            await this.getCollectionHandles();
            
            // Detect Qualified Campaigns
            this.campaigns = this.identifyActiveCampaigns();

            if (this.campaigns.length === 0) {
                // Temporarily don't remove during dev
                return;
            }


            // Get Appropriate Product Data.
            await this.fetchProducts();

            // return;
            // Build Slides
            const slideHTML = this.buildSlides();

            document.querySelector(this.$selectors.list).innerHTML = slideHTML;

            document.querySelector(this.$selectors.checkoutBtn).disabled = true;
            this.disclaimer();

            this.addHandlers();
            this.slickHandlers();
            this.startSlick();
            this.show();
        }

        hide() {
            document.querySelector(this.$selectors.contaner).classList.add('invisible');
        }

        show() {
            document.querySelector(this.$selectors.container).classList.remove('invisible');
        }

        slickHandlers() {
            const slider = document.querySelector(this.$selectors.list);

            slider.addEventListener('init', function() {
                console.warn('Slider Init');
            });
        }

        startSlick() {
            $(this.$selectors.list).slick({
                slidesToShow: 2,
                slidesToScroll: 2,
                responsive: [
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });
        }
    }


    const GWPSection = document.getElementById('shopify-section-template--14179379806279__gwpsection');

    if(GWPSection) {
        const gwp = new GWP({
            container: '#shopify-section-template--14179379806279__gwpsection',
        });
    }

})();